// extracted by mini-css-extract-plugin
module.exports = {"responsiveTable":"ResponsiveTable_responsiveTable__2sPhA","verticalTable":"ResponsiveTable_verticalTable__2LU-P","horizontalTable":"ResponsiveTable_horizontalTable__1FxE2"};